// extracted by mini-css-extract-plugin
export default {"actions":"input-form_actions__f+UxQ","button":"input-form_button__do8JO"};